import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBarActions',
  props: {
    allowStop: { type: Boolean },
    disableStop: { type: Boolean },
    allowRestart: { type: Boolean },
    disableRestart: { type: Boolean },
    allowMinimize: { type: Boolean }
  },
  emits: ["close", "restart", "stop", "minimize"],
  setup(__props: any) {




return { __sfc: true, }
}

})